module.exports = __webpack_public_path__ + "static/media/withdrawal_success.0817b00d.svg";